import { createTheme } from "@mui/material";

// Create custom theme
const theme = createTheme({
	typography: {
		fontFamily:
			'"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif',
		h1: { fontSize: "1.75rem", fontWeight: 600 },
		h2: { fontSize: "1.5rem", fontWeight: 600 },
		h3: { fontSize: "1.25rem", fontWeight: 600 },
		h4: { fontSize: "1.125rem", fontWeight: 600 },
		h5: { fontSize: "0.9375rem", fontWeight: 600 },
		h6: { fontSize: "0.9375rem", fontWeight: 600 },
		body1: { fontSize: "0.8125rem" },
		body2: { fontSize: "0.6875rem" },
		subtitle1: { fontSize: "0.8125rem" },
		subtitle2: { fontSize: "0.6875rem" },
		caption: { fontSize: "0.6875rem" },
		button: { fontSize: "0.6875rem", fontWeight: 500 },
	},
	shape: {
		borderRadius: 12, // Softer round corners for a modern minimalist look
	},
	palette: {
		primary: { main: "#1a1a1a" },
		secondary: { main: "#f5f5f5" },
		background: {
			default: "#fcfcfc",
			paper: "#ffffff",
		},
		text: {
			primary: "#1a1a1a",
			secondary: "#666666",
		},
		action: {
			hover: "rgba(0, 0, 0, 0.04)",
			selected: "rgba(0, 0, 0, 0.08)",
		},
	},
	components: {
		MuiButton: {
			styleOverrides: {
				root: {
					borderRadius: 8,
					textTransform: "none",
					boxShadow: "none",
					"&:hover": {
						boxShadow: "none",
					},
				},
				contained: {
					backgroundColor: "#1a1a1a",
					color: "#fff",
					"&:hover": {
						backgroundColor: "#333",
					},
				},
				outlined: {
					borderColor: "#e0e0e0",
					color: "#1a1a1a",
					"&:hover": {
						borderColor: "#1a1a1a",
						backgroundColor: "rgba(0,0,0,0.02)",
					},
				},
			},
		},
		MuiPaper: {
			styleOverrides: {
				root: {
					backgroundImage: "none",
					boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.04)", // Very subtle shadow instead of heavy border
					border: "1px solid #f0f0f0", // Much softer border
				},
				elevation1: {
					boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.04)",
				},
			},
		},
		MuiCard: {
			styleOverrides: {
				root: {
					boxShadow: "none",
					border: "1px solid #f0f0f0",
					transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
					"&:hover": {
						transform: "translateY(-2px)",
						boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.05)",
					},
				},
			},
		},
		MuiSelect: {
			styleOverrides: {
				root: {
					borderRadius: 8,
					backgroundColor: "#fafafa",
					"&:hover": {
						backgroundColor: "#f5f5f5",
					},
				},
			},
		},
		MuiOutlinedInput: {
			styleOverrides: {
				root: {
					borderRadius: 8,
					backgroundColor: "#fafafa",
					"& .MuiOutlinedInput-notchedOutline": {
						borderColor: "transparent",
					},
					"&:hover .MuiOutlinedInput-notchedOutline": {
						borderColor: "#e0e0e0",
					},
					"&.Mui-focused .MuiOutlinedInput-notchedOutline": {
						borderColor: "#1a1a1a",
						borderWidth: "1px",
					},
				},
			},
		},
		MuiInputLabel: {
			styleOverrides: {
				root: {
					"&.Mui-focused": {
						color: "#1a1a1a",
					},
				},
			},
		},
		MuiToggleButton: {
			styleOverrides: {
				root: {
					border: "1px solid #f0f0f0",
					"&.Mui-selected": {
						backgroundColor: "#1a1a1a !important",
						color: "#ffffff !important",
					},
				},
			},
		},
		MuiChip: {
			styleOverrides: {
				root: {
					borderRadius: 6,
					backgroundColor: "#f5f5f5",
				},
				outlined: {
					borderColor: "#e0e0e0",
					backgroundColor: "transparent",
				},
			},
		},
	},
});

export default theme;
